import {
  Avatar,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography
} from '@mui/material';
import {
  useBillingPortalUrlLazyQuery,
  useSubscriptionPaymentMethodTabQuery
} from 'generated/graphql';
import { useParams } from 'react-router-dom';


import { EditOutlined } from '@mui/icons-material';
import imgMastercard from 'assets/brandLogos/mastercard.png';
import imgVisa from 'assets/brandLogos/visa.png';



export type SubscriptionPaymentMethodTabProps = {};

export const FC = (props: SubscriptionPaymentMethodTabProps) => {
  const { organizationId } = useParams<{ organizationId: string }>();

  const { data, loading } = useSubscriptionPaymentMethodTabQuery({
    skip: !organizationId,
    variables: {
      organizationId: organizationId ?? ''
    }
  });

  const activePaymentMethod = data?.paymentMethods.find((pm) => pm.isDefault);
  const availablePaymentMethods = data?.paymentMethods.filter((pm) => pm.id !== activePaymentMethod?.id);

  return (
    <Stack sx={{
      mt: '2.5rem',
      gap: '1rem'
    }}
    >
      <Stack direction='row'>
        <Stack>
          <Typography>
            Active Payment Method
          </Typography>

          {activePaymentMethod ? (
            <PaymentMethodListItem
              organizationId={organizationId ?? ''}
              {...activePaymentMethod}
            />
          ) : (
            <ListItemText primary='No active payment method found.' />
          )}
        </Stack>
      </Stack>

      <Stack>
        <Typography>
          Available Payment Methods
        </Typography>

        {(availablePaymentMethods && availablePaymentMethods.length > 0) ? (
          <List>
            {availablePaymentMethods.map((pm) => (
              <PaymentMethodListItem
                key={pm.id}
                organizationId={organizationId ?? ''}
                {...pm}
              />
            ))}
          </List>
        ) : (
          <List>
            <ListItemText primary='No other payment methods found' />
          </List>
        )}
      </Stack>
    </Stack>
  );
};



function PaymentMethodListItem(pm: {
  organizationId: string;
  id: string;
  isDefault: boolean;
  description: string;
  brand: string;
  last4: string;
  expiry: string;
}) {
  const [fnQueryBillingPortal] = useBillingPortalUrlLazyQuery({
    variables: {
      organizationId: pm.organizationId
    }
  });

  return (
    <ListItem
      key={pm.id}
    >
      <ListItemAvatar>
        <Avatar src={__brand2Logo(pm.brand)} />
      </ListItemAvatar>

      <ListItemText
        primary={pm.brand.toUpperCase() + ' ' + '**** ' + pm.last4}
      />

      <ListItemIcon>
        <Button
          color='inherit'
          startIcon={<EditOutlined />}
          onClick={async () => {
            const result = await fnQueryBillingPortal();
            if (result.data?.billingPortalUrl) {
              window.open(new URL(result.data?.billingPortalUrl));
            }
          }}
        >
          Edit
        </Button>
      </ListItemIcon>
    </ListItem>
  );
}

function __brand2Logo(brand: string) {
  // return imgVisa;
  switch (brand.toLowerCase()) {
    case 'visa':
      return imgVisa;
    case 'mastercard':
      return imgMastercard;
    default:
      return '';
  }
}
